import { render, staticRenderFns } from "./UserRegister.vue?vue&type=template&id=2ba30bcf"
import script from "./UserRegister.vue?vue&type=script&lang=js"
export * from "./UserRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports